/* Size guide panel (A/B: body class ia-ab-size-guide). The element puts one opener next to the
   product's size option (findTarget) and opens the theme's popup-component around the panel;
   the opener stays hidden by CSS on pages without the class. */
(function () {
  if (customElements.get('ia-size-guide')) return;

  var VARIANT_CLASS = 'ia-ab-size-guide';
  var LEGEND_CLASS = 'ia-size-guide-legend';

  function clean(text) {
    return (text || '').replace(/\*/g, '').trim().toLowerCase();
  }

  class IaSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.opener = null;
      this.observer = null;
      this.timer = 0;
      this.onOpen = this.onOpen.bind(this);
      this.onTabChange = this.onTabChange.bind(this);
      this.onTabKey = this.onTabKey.bind(this);
      this.onMutation = this.onMutation.bind(this);
    }

    connectedCallback() {
      this.popup = this.querySelector('popup-component');
      this.tabs = this.querySelector('tabs-component');
      this.names = (this.dataset.optionNames || '').split('|').filter(Boolean);
      this.product = document.querySelector('product-component[data-product-handle="' + this.dataset.productHandle + '"]');

      this.opener = document.createElement('button');
      this.opener.type = 'button';
      this.opener.className = 'ia-size-guide-link';
      this.opener.textContent = this.dataset.label;
      this.opener.setAttribute('aria-haspopup', 'dialog');
      this.opener.setAttribute('aria-controls', this.dataset.dialogId);
      this.opener.addEventListener('click', this.onOpen);
      this.placeOpener();

      // Bold Options draws its fields after load and the theme may redraw the legends: the
      // one opener follows the best target as it appears
      if (this.product) {
        this.observer = new MutationObserver(this.onMutation);
        this.observer.observe(this.product, {childList: true, subtree: true});
      }

      if (this.tabs) {
        this.tabs.addEventListener('theme:tab:change', this.onTabChange);
        this.tabs.addEventListener('keydown', this.onTabKey);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      clearTimeout(this.timer);

      if (this.opener) {
        this.opener.removeEventListener('click', this.onOpen);
        if (this.opener.parentNode) this.opener.parentNode.classList.remove(LEGEND_CLASS);
        this.opener.remove();
        this.opener = null;
      }

      if (this.tabs) {
        this.tabs.removeEventListener('theme:tab:change', this.onTabChange);
        this.tabs.removeEventListener('keydown', this.onTabKey);
      }
    }

    // Debounced on a timer, which keeps running in a background tab where Bold may render
    onMutation() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.placeOpener(), 50);
    }

    // Listed names in order, first among the product's options, then among Bold Options
    // fields; without either, the last option takes the opener
    findTarget() {
      if (!this.product) return null;
      var options = Array.prototype.slice.call(this.product.querySelectorAll('.product__content .selector-wrapper')).map(function (wrapper) {
        var name = wrapper.querySelector('.radio__legend__option-name');
        return {text: clean(name && name.textContent), node: wrapper.querySelector('.radio__legend')};
      });
      var fields = Array.prototype.slice.call(this.product.querySelectorAll('.bold_option_title')).map(function (title) {
        return {text: clean(title.textContent.replace(this.opener.textContent, '')), node: title};
      }, this);
      var pick = function (list) {
        for (var i = 0; i < this.names.length; i++) {
          for (var j = 0; j < list.length; j++) {
            if (list[j].node && list[j].text === this.names[i]) return list[j].node;
          }
        }
        return null;
      }.bind(this);
      var last = options.filter(function (option) {
        return option.node;
      }).pop();
      return pick(options) || pick(fields) || (last ? last.node : null);
    }

    placeOpener() {
      if (!this.opener) return;
      var target = this.findTarget();
      if (!target || this.opener.parentNode === target) return;
      if (this.opener.parentNode) this.opener.parentNode.classList.remove(LEGEND_CLASS);
      target.classList.add(LEGEND_CLASS);
      target.appendChild(this.opener);
    }

    onOpen(event) {
      if (!document.body.classList.contains(VARIANT_CLASS) || !this.popup) return;
      event.preventDefault();
      window.theme.a11y.lastElement = this.opener;
      this.popup.popupOpen();
    }

    // The theme's tabs switch classes only; the ARIA state follows them here
    onTabChange() {
      this.tabs.querySelectorAll('[role="tab"]').forEach(function (tab) {
        var selected = tab.classList.contains('current');
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });
    }

    // Arrow keys move between tabs and select, as in the WAI tabs pattern
    onTabKey(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var tabs = Array.prototype.slice.call(this.tabs.querySelectorAll('[role="tab"]'));
      var index = tabs.indexOf(event.target);
      if (index === -1) return;

      event.preventDefault();
      var step = event.key === 'ArrowRight' ? 1 : -1;
      var next = tabs[(index + step + tabs.length) % tabs.length];
      next.click();
      next.focus();
    }
  }

  customElements.define('ia-size-guide', IaSizeGuide);
})();
